import { shape, string, arrayOf } from 'prop-types';

export default shape({
    appId: string,
    searchApiKey: string,
    defaultIndex: string,
    indexes: arrayOf(
        shape({
            label: string.isRequired,
            value: string.isRequired,
            urlValue: string,
        }),
    ),
});
